import { writable, derived } from 'svelte/store';
import {getUrlParam} from './utils'
import {SCREENS} from './ids'
import DataLoading from './DataLoading';

export const screen = writable(SCREENS.LOADING)
export const language = writable(null)


export const network_errors = writable([])

export const getTrad = derived(language, $language => {
  return (id) => {
    if (!DataLoading.interface) return id
    let line = DataLoading.interface.find(l => l.id ===id)
    if(!line) {
      console.log("ERREUR, l'id", id, "n'existe pas dans le fichier de trad")
      return "MISSING"
    }

    let trad = line[$language].trim()
    if(!trad || trad === "") {
      return line["en"]
    }
    return trad
  }
})

export const getDialTrad = derived(language, $language => {
  return (id) => {
    if (!DataLoading.dials) return id
    let line = DataLoading.dials.find(l => l.id ===id)
    if(!line) {
      console.log("ERREUR, l'id", id, "n'existe pas dans le fichier de dials")
      return {title: "MISSING title", content: "MISSING content"}
    }

    let title = line["title_" + $language]
    let content = line["content_" + $language]

    if(!title || title === "") {
      console.log("ERREUR, le titre en", $language, "n'existe pas pour l'id", id)
      title = line.title_en
    }
    if(!content || content === "") {
      console.log("ERREUR, le contenu en", $language, "n'existe pas pour l'id", id)
      content = line.content_en
    }


    return {title, content}
  }
})
